import { render, staticRenderFns } from "./ValidatedFormTextarea.vue?vue&type=template&id=4952cb09&"
import script from "./ValidatedFormTextarea.vue?vue&type=script&lang=js&"
export * from "./ValidatedFormTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports